import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Block } from 'atoms/layout/Block';
import { BodyM } from 'atoms/typography';

interface Props {
  title: string;
  subtitle: string;
  children: ReactNode;
  link: string;
}

const Root = styled(Block)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 120px;
  padding: 0px 30px;
  width: 100%;
  & + & {
    margin-top: 0;
  }
`;
const Left = styled.div`
  text-align: left;
`;

export const RelatedPage = ({ title, subtitle, children, link }: Props) => {
  return (
    <Root to={link}>
      {children}
      <Left>
        <BodyM bold>{title}</BodyM>
        <BodyM color="var(--c-nd-600)">{subtitle}</BodyM>
      </Left>
    </Root>
  );
};
